
export const getConfirmingAccount = state => state.loading;
export const getDestination = state => state.destination || null;



// WEBPACK FOOTER //
// ./src/redux/confirmAccount/selectors.js